import React from 'react';
import { faPause } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

const pauseTooltip = <Tooltip id="tooltip">Pause the forward of this item(s)</Tooltip>;

const QueuePauseButton = ({ action, args, disabled }) => {
  return (
    <OverlayTrigger placement="top" overlay={pauseTooltip}>
      <Button
        size="sm"
        variant="outline-secondary"
        className="queue-button"
        style={{ marginRight: '0.5em' }}
        disabled={disabled}
        onClick={e => {
          action(args);
          e.currentTarget.blur();
        }}
      >
        <FontAwesomeIcon icon={faPause} />
      </Button>
    </OverlayTrigger>
  );
};

export default QueuePauseButton;
